var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarToday(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "#808080",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33333 13.9623C0.966667 13.9623 0.652778 13.8317 0.391667 13.5706C0.130556 13.3095 0 12.9956 0 12.629V3.29563C0 2.92897 0.130556 2.61508 0.391667 2.35397C0.652778 2.09286 0.966667 1.9623 1.33333 1.9623H2V0.628967H3.33333V1.9623H8.66667V0.628967H10V1.9623H10.6667C11.0333 1.9623 11.3472 2.09286 11.6083 2.35397C11.8694 2.61508 12 2.92897 12 3.29563V12.629C12 12.9956 11.8694 13.3095 11.6083 13.5706C11.3472 13.8317 11.0333 13.9623 10.6667 13.9623H1.33333ZM1.33333 12.629H10.6667V5.9623H1.33333V12.629Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarToday);
export default __webpack_public_path__ + "static/media/calendar_today.5f2b60b979449c968e6478a919f49486.svg";
export { ForwardRef as ReactComponent };